// extracted by mini-css-extract-plugin
module.exports = {"confirmationModal":"ConfirmationModal_confirmationModal__3Qbk7"};